module.exports = __webpack_public_path__ + "static/media/whatsapp.214dff34.svg";